/**
 * Fonctions utilitaires pour la validation de formulaire
 */

// Validation d'email
export const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  
  // Validation de nom
  export const isValidName = (name) => {
    const regex = /^[a-zA-ZÀ-ÿ\s]{2,50}$/;
    return regex.test(name);
  };
  
  // Validation de message
  export const isValidMessage = (message, minLength = 10, maxLength = 1000) => {
    return message.length >= minLength && message.length <= maxLength;
  };
  
  // Validation complète du formulaire
  export const validateContactForm = (formData) => {
    const errors = {};
    
    if (!isValidName(formData.name)) {
      errors.name = 'Veuillez entrer un nom valide (2 à 50 caractères, lettres uniquement)';
    }
    
    if (!isValidEmail(formData.email)) {
      errors.email = 'Veuillez entrer une adresse email valide';
    }
    
    if (!formData.subject.trim()) {
      errors.subject = 'Le sujet est requis';
    }
    
    if (!isValidMessage(formData.message)) {
      errors.message = 'Le message doit contenir entre 10 et 1000 caractères';
    }
    
    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  };